/**
 * Platform Languages Configuration
 *
 * Центральная конфигурация поддерживаемых языков платформы.
 * Используется для выбора языков организации и компонента LocalizedInput.
 */

export interface PlatformLanguage {
  /** ISO 639-1 код языка */
  code: string
  /** Название на родном языке */
  nativeName: string
  /** Направление текста */
  dir?: 'ltr' | 'rtl'
}

/**
 * Все поддерживаемые языки платформы
 */
export const PLATFORM_LANGUAGES: PlatformLanguage[] = [
  { code: 'ru', nativeName: 'Русский' },
  { code: 'en', nativeName: 'English' },
  { code: 'fr', nativeName: 'Français' },
  { code: 'es', nativeName: 'Español' },
  { code: 'de', nativeName: 'Deutsch' },
  { code: 'pt', nativeName: 'Português' },
  { code: 'zh', nativeName: '中文' },
  { code: 'ja', nativeName: '日本語' },
  { code: 'ko', nativeName: '한국어' },
  { code: 'ar', nativeName: 'العربية', dir: 'rtl' },
  { code: 'tr', nativeName: 'Türkçe' },
  { code: 'vi', nativeName: 'Tiếng Việt' },
  { code: 'hi', nativeName: 'हिन्दी' },
  { code: 'id', nativeName: 'Bahasa Indonesia' },
]

/**
 * Коды всех поддерживаемых языков
 */
export const PLATFORM_LANGUAGE_CODES = PLATFORM_LANGUAGES.map((l) => l.code)

/**
 * Получить язык по коду
 */
export function getLanguageByCode(code: string): PlatformLanguage | undefined {
  return PLATFORM_LANGUAGES.find((l) => l.code === code)
}

/**
 * Получить родное название языка
 */
export function getNativeName(code: string): string {
  return getLanguageByCode(code)?.nativeName ?? code.toUpperCase()
}

/**
 * Получить направление текста для языка
 */
export function getTextDirection(code: string): 'ltr' | 'rtl' {
  return getLanguageByCode(code)?.dir ?? 'ltr'
}
